import React from "react";
import '../styles/Button.css';
class Button extends React.Component{
    getButton(isResume, text, link){
        if(isResume){
            return(
                <a className=" f6 dib link br3 ba ph3 pv2 black" href={link} download={'Sourabh_CV'} >{text}</a>
            );
        }

        return(
            <a className=" f6 dib link br3 ba ph3 pv2 black" href={link} >{text}</a>
        );
    }
    render(){
        const {isResume, text, link} = this.props
        return(
            <div className="button-div animate-grow">
                {this.getButton(isResume, text, link)}
            </div>
        );
    }
}

export default Button;